import React, { useContext } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { OperationsContext } from '../OperationsContext';

const ApiErrorModal = () => {
	// context
	const {
		apiError,
		setApiError
	} = useContext( OperationsContext );

	return (
		<Modal
			open={ Boolean( apiError ) }
		>
			<Modal.Header>
        API Error
			</Modal.Header>
			<Modal.Content>
				<p>{ apiError.message }</p>
			</Modal.Content>
			<Modal.Actions>
				<Button
					primary
					content="Close"
					onClick={ () => {
						setApiError( null );
					} }
				>
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default ApiErrorModal;
